"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chameleonPalette = void 0;
var themeCreator_1 = __importDefault(require("./themeCreator"));
exports.chameleonPalette = {
    component: {
        answerSelectedColor: 'rgb(26, 155, 219)',
        answerUnselectedColor: 'rgb(225, 225, 225)',
        continueButtonColor: 'rgb(13, 165, 135)',
        continueButtonHoverColor: 'rgb(0, 117, 90)',
        backButtonColor: 'rgb(237,237,237)',
        backButtonHoverColor: 'rgb(223,223,223)',
        progressBarFilledColor: 'rgb(26, 155, 219)',
        progressBarUnfilledColor: 'rgb(247,247, 247)',
        scrollIndicatorColor: 'rgb(55, 84, 160)',
    },
    background: {
        answerBackgroundColor: 'rgb(251, 251, 251)',
        secondaryBackgroundColor: 'rgb(247, 247, 247)',
        widgetBackgroundColor: 'rgb(255,255,255)',
    },
    text: {
        primaryTextColor: 'rgb(0, 0, 0)',
        continueButtonTextColor: 'rgb(255, 255, 255)',
        secondaryTextColor: 'rgb(0, 0, 0)',
    },
    status: {
        disabled: 'rgb(134, 134, 134)',
        error: 'rgb(249, 98, 78)',
    },
};
var chameleonTheme = (0, themeCreator_1.default)(exports.chameleonPalette);
exports.default = chameleonTheme;
//# sourceMappingURL=chameleonTheme.js.map